import styled from 'styled-components';
import { Modal as ModalComponent } from 'react-bootstrap';
import circle from '~/assets/icons/switch-circle.svg';
import circleWhite from '~/assets/icons/switch-circle-white.svg';

interface IStatus {
  status: string;
}

export const Container = styled.div`
  min-width: calc(100% - 88px);
  max-height: 100vh;

  .infinite-scroll {
    height: 100vh;
    overflow: auto;

    ::-webkit-scrollbar {
      width: 0;
    }

    ::-webkit-scrollbar-thumb {
      background-color: transparent !important;
    }
  }

  h1 {
    font-size: 26px;
    font-weight: 500;
  }

  hr {
    background: #e1e1e1;
    opacity: 1;
  }

  a {
    :hover {
      color: unset;
    }
  }

  .container-fluid {
    max-width: 1460px;
  }

  .btn-new {
    border-radius: 4px;
    background: #ff6900;
    border: none;
  }

  .bg-white {
    border-radius: 8px;
  }

  .tooltip-event:after {
    background-color: #002f6c;
    color: #fff;
    border: 1px solid #002f6c;
    border-radius: 15px;
    text-align: start;
    box-sizing: border-box;
    content: attr(data-tooltip);
    display: none;
    padding: 15px;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    position: absolute;
    bottom: 30px;
    left: -163px;
    width: 210px;
    z-index: 10000;
  }

  .tooltip-event:hover:after {
    display: block;
  }

  .form-switch .form-check-input:focus {
    background-image: url(${circle});
  }
  .form-check-input:checked {
    background-color: #ff6900;
    border-color: #ff6900;
    background-image: url(${circleWhite}) !important;
  }
  .form-check-input {
    width: 3rem;
    height: 1.5rem;
    background-color: transparent;
    border-color: #d3d3d3;
  }

  .type-icon {
    width: 32px;
    height: 32px;
  }

  .category-name {
    min-width: 200px;
  }

  .input-quantity {
    width: 100px;
  }
`;

export const Cards = styled.div`
  h3 {
    color: #5d5d5d;
    font-size: 14px;
    font-weight: 400;
  }

  p {
    color: #000;
    font-size: 14px;
    font-weight: 400;
  }

  .default {
    max-width: 64px;
    max-height: 64px;
    border: solid 1px #002f6c;
    border-radius: 4px;
  }

  .bg-orange {
    background-color: #ff842f;
    padding: 4px 8px;
    height: 32px;
    width: 32px;
    display: inline-block;
  }
`;

export const Filter = styled.div`
  h2 {
    color: #000;
    font-family: 'Roboto';
  }
`;

export const Status = styled.p<IStatus>`
  color: ${(props) => {
    switch (props.status) {
      case 'Em Alteração':
      case 'Cadastrando':
        return '#000';
      default:
        return '#fff';
    }
  }}!important;
  background-color: ${(props) => {
    switch (props.status) {
      case 'Cadastrando':
        return '#bbb';
      case 'Rascunho':
        return '#4b4b4d';
      case 'Em Alteração':
        return '#dbb100';
      case 'Pendente':
        return '#dbb100';
      case 'Aprovado':
        return '#dbb100';
      case 'Aberto':
        return '#427242';
      case 'Esgotado':
        return '#427242';
      case 'Fechado':
        return '#427242';
      case 'Em Andamento':
        return '#427242';
      case 'Encerrado':
        return '#002f6c';
      case 'Finalizado':
        return '#002f6c';
      case 'Cancelado':
        return '#bf2216';
      default:
        return '#000';
    }
  }};
  padding: 3px;
`;

export const Modal = styled(ModalComponent)`
  backdrop-filter: blur(3px);

  .form-control {
    width: 100px;
    min-width: 100px;
  }

  .title {
    color: #000;
    font-size: 26px;
    font-weight: 500;
  }

  input {
    color: #202020;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
  }

  input::placeholder {
    color: #d8d8d8;
  }

  button[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  label {
    span {
      color: #000;
    }
  }

  .check {
    color: #6a6a6a;
    font-size: 14px;
    font-weight: 500;
    > span:nth-child(1) {
      border-radius: 4px;
      border: 1px solid #c7c7c7;
      min-width: 24px;
      height: 24px;
    }
  }

  .checked {
    background: #ff842f !important;
  }

  .check-list {
    height: 17px !important;
    width: 17px !important;
  }

  .input {
    border: 1px solid rgba(221, 221, 221, 0.87);

    height: 40px;
    border-radius: 4px;

    input {
      color: #202020;
    }
  }

  .btn-filter {
    border-radius: 4px;
    background-color: #ff6900;
    color: #fff;
    border: none;
  }

  .modal-content {
    border-radius: 8px;
    border: none;
  }
`;

export const TableListModal = styled.div`
  .btn-icons {
    background: #ff842f;
    border-radius: 20px;
    padding: 6px 8px;
  }

  .btn-new {
    border-radius: 4px;
    background: #ff6900;
    border: none;
  }
  .min-w {
    min-width: 1500px;
  }
  .table {
    > div:first-child {
      padding: 0px !important;
    }
    div {
      border: none;
    }
  }

  .content {
    ::-webkit-scrollbar {
      background: transparent;
      width: 5px;
      height: 13px;
      border: none;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #002f6c;
      border-radius: 10px;
    }
  }

  .tb-header {
    background-color: #002f6c;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 12px 16px;
  }

  .tb-body {
    padding: 0 0.5rem;
  }

  .tb-header .tb-row button {
    color: #fff;
    font-family: 'Roboto';
    font-size: 16px;
    font-weight: 400;
    justify-content: center;
    width: 241px;

    svg {
      color: #fff !important;
    }
  }

  /* .tb-body {
    width: 100%;
    > div {
      width: 100%;
    }
  } */

  .tb-body .tb-row {
    padding: 0.5rem 0.5rem;
    text-align: center;
    width: 100%;

    :not(:last-child) {
      border-bottom: 0.5px solid #e1e1e1;
    }
  }

  .tb-header .tb-row {
    /* button:nth-child(1) {
      width: 200px;
    }
    button:nth-child(2) {
      width: 90px;
    }
    button:nth-child(4) {
      width: 170px;
    }

    button:nth-child(8) {
      width: 150px;
    } */
    button:nth-child(4) {
      width: 250px;
    }
    button:nth-child(5) {
      width: 50px;
    }
  }

  .tb-body .tb-row {
    > div {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      padding: 0 15px;
      width: 241px;
    }
    /* div:nth-child(1) {
      width: 200px;
    }
    div:nth-child(2) {
      width: 90px;
    }
    div:nth-child(4) {
      width: 170px;
    }

    div:nth-child(8) {
      width: 150px;
    } */
    div:nth-child(4) {
      width: 250px;
    }
    div:nth-child(5) {
      width: 50px;
    }
  }

  @media screen and (min-width: 992px) {
  }
`;

export const ModalityContainer = styled.div`
  h5 {
    font-weight: 600;
    color: #292623;
    font-size: 16px;
    padding-bottom: 0;
    font-family: 'Roboto', sans-serif;
    padding: 15px;
    background: rgb(255, 233, 218);
    border-radius: 8px 8px 0px 0px;
    margin-bottom: 10px;
  }
`;

export const CategoryItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-radius: 4px;
  border: 1px solid rgb(225, 225, 225);
  margin-bottom: 10px;

  .category-name {
    font-family: Poppins, sans-serif;
    font-size: 14px;
    color: #000;
    font-weight: 400;
    padding-left: 15px;
  }

  .input-wrapper {
    width: 100px;
  }
`;
